import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send, Facebook } from 'lucide-react';
import './Services.css';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    petName: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Booking Enquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nPet Name: ${formData.petName}\nService: ${formData.service}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:tweedsdoggrooming@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <section className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/salon.jpg" alt="Tails and Tweed salon" />
          <div className="page-hero__overlay" />
        </div>
        <div className="page-hero__content container">
          <span className="section-label" style={{ color: 'var(--color-accent-light)' }}>Get in Touch</span>
          <h1 className="page-hero__title">Contact Us</h1>
          <p className="page-hero__subtitle">
            Ready to book an appointment or have a question? We&rsquo;d love to hear from you.
          </p>
        </div>
      </section>

      <section className="contact section">
        <div className="container">
          <div className="contact__grid">
            <div className="contact__info">
              <h2 className="contact__heading">Visit Our Salon</h2>

              <div className="contact__cards">
                <div className="contact-card">
                  <div className="contact-card__icon">
                    <MapPin size={22} />
                  </div>
                  <div>
                    <h4>Address</h4>
                    <p>4b East St. Helens Street<br />Abingdon, Oxfordshire<br />OX14 5EA</p>
                  </div>
                </div>

                <div className="contact-card">
                  <div className="contact-card__icon">
                    <Phone size={22} />
                  </div>
                  <div>
                    <h4>Phone</h4>
                    <a href="tel:07904813567">07904 813567</a>
                  </div>
                </div>

                <div className="contact-card">
                  <div className="contact-card__icon">
                    <Mail size={22} />
                  </div>
                  <div>
                    <h4>Email</h4>
                    <a href="mailto:tweedsdoggrooming@gmail.com">tweedsdoggrooming@gmail.com</a>
                  </div>
                </div>

                <div className="contact-card">
                  <div className="contact-card__icon">
                    <Clock size={22} />
                  </div>
                  <div>
                    <h4>Hours</h4>
                    <p>Monday &ndash; Saturday<br />By Appointment Only</p>
                  </div>
                </div>
              </div>

              <div className="contact__social">
                <h4>Follow Us</h4>
                <div className="contact__social-links">
                  <a href="https://www.facebook.com/tailsandtweedgrooming/" target="_blank" rel="noopener noreferrer">
                    <Facebook size={20} /> Facebook
                  </a>
                </div>
              </div>
            </div>

            <div className="contact__form-wrapper">
              <h2 className="contact__heading">Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form__row">
                  <div className="contact-form__field">
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Jane Smith"
                    />
                  </div>
                  <div className="contact-form__field">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="jane@example.com"
                    />
                  </div>
                </div>

                <div className="contact-form__row">
                  <div className="contact-form__field">
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="07000 000000"
                    />
                  </div>
                  <div className="contact-form__field">
                    <label htmlFor="petName">Pet&rsquo;s Name</label>
                    <input
                      type="text"
                      id="petName"
                      name="petName"
                      value={formData.petName}
                      onChange={handleChange}
                      placeholder="Buddy"
                    />
                  </div>
                </div>

                <div className="contact-form__field">
                  <label htmlFor="service">Service Interested In</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service...</option>
                    <option value="full-groom">Full Grooming</option>
                    <option value="bath-brush">Bath &amp; Brush</option>
                    <option value="puppy">Puppy Grooming</option>
                    <option value="hand-stripping">Hand Stripping</option>
                    <option value="cat-grooming">Cat Grooming</option>
                    <option value="teeth-cleaning">Teeth Cleaning</option>
                    <option value="spa">Spa Experience</option>
                    <option value="training">Training Academy</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="contact-form__field">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Tell us about your pet and what you're looking for..."
                  />
                </div>

                <button type="submit" className="btn btn-primary contact-form__submit">
                  <Send size={16} /> Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="map-section">
        <iframe
          title="Tails and Tweed Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2478.5!2d-1.2822!3d51.6710!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876c1c0a8b5c5c1%3A0x4d5e6f7a8b9c0d1e!2s4b%20East%20St%20Helens%20St%2C%20Abingdon%20OX14%205EA!5e0!3m2!1sen!2suk!4v1700000000000!5m2!1sen!2suk"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>
    </>
  );
}

export default Contact;
